import { Outlet } from "react-router-dom";

export default function RewardsOutlet() {
  return <Outlet />;
}
